module.exports = __webpack_public_path__ + "facebook.webp?931bf48a60f5f581eb267f7b346b4e31";